import { render } from "./WifiError.vue?vue&type=template&id=627625d1&scoped=true"
import script from "./WifiError.vue?vue&type=script&lang=js"
export * from "./WifiError.vue?vue&type=script&lang=js"

import "./WifiError.vue?vue&type=style&index=0&id=627625d1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627625d1"]])

export default __exports__